module.exports = __webpack_public_path__ + "static/media/television-group.e4929f73.svg";